export default "__VITE_ASSET__a28f80d1__"